import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const Lattice = () => (
  <DMModuleSubtopic
    title="Lattice"
    videos={[
      "https://www.youtube.com/embed/KmaDb0CsePA",
      "https://www.youtube.com/embed/aKR2ePbIoKk",
      "https://www.youtube.com/embed/NMfAiQm1xho",
      "https://www.youtube.com/embed/HQm_ANpc2GQ"

    ]}
    takeaways={[]}
    questions={[
      {
        text: "Draw the Hasse Diagram for the poset {S30,D}, divisors of 30 under the relation divides. Hence prove that it is a lattice. Also find (i) 3*(10⊕3) (ii) 3⊕(10*3)"
      },
      {image:"/dm_22.png"},
      {image:"/dm_23.png"}
    ]}
    exampleVideos={[]}
  />
);

export default Lattice;
